import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

import { CheckWhite } from "@speedoc/design-assets/build/icons/index.js";
import { ChevronBlue } from "@speedoc/design-assets/build/icons";

const TypeOfCare = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 545px)" });
  const [top, setTop] = useState(0);

  const [contentTypeOfCare, setContentTypeOfCare] = useState(content);
  const [price, setPrice] = useState(content.typeofcareitems[0].price);

  const [showNursePackage, setShowNursePackage] = useState(false);
  const updatePrice = (e, servicePrice) => {
    setPrice(servicePrice);
    if (e.target.className === "serviceContent") {
      setTop(e.target.offsetTop);
    }
    if (e.target.className === "listheader" || e.target.className === "listdescription") {
      setTop(e.target.parentNode.parentNode.offsetTop);
    }
  };

  const showHoverLight = () => {
    return !isMobile && <div className="stripe" style={{ top: top }} />;
  };

  const goToNursePackage = () => {
    setShowNursePackage(!showNursePackage);
  };

  const nextButton = () => {
    return (
      <div className="nurseButton" onClick={goToNursePackage}>
        <div className="container">
          <div className="title">{contentTypeOfCare.nursebuttontitle}</div>
          <div className="description next">{contentTypeOfCare.nursebuttondescription}</div>
        </div>
        <div className="icon">
          <ChevronBlue />
        </div>
      </div>
    );
  };

  const backButton = () => {
    return (
      <div className="nurseButton" onClick={goToNursePackage}>
        <div className="container backContainer">
          <div className="icon back">
            <ChevronBlue />
          </div>
          <div className="description back">{contentTypeOfCare.nursebackbutton}</div>
        </div>
      </div>
    );
  };

  const showNurseButton = () => {
    return showNursePackage ? backButton() : nextButton();
  };

  useEffect(() => {
    const data = showNursePackage ? content.nursepackages : content;
    const contentBuilding = {
      type: content.types,
      nursebuttontitle: content.nursebuttontitle,
      nursebuttondescription: content.nursebuttondescription,
      nursebackbutton: content.nursebackbutton,
      subtitle: data.subtitle,
      title: data.title,
      from: data.from,
      pricedisclaimer: data.pricedisclaimer,
      typeofcareitems: data.typeofcareitems
    };
    setContentTypeOfCare(contentBuilding);
  }, [showNursePackage, content]);

  const claimerContainer = () => {
    return showNursePackage ? (
      <div className="priceNursePackage">{price}</div>
    ) : (
      <>
        <div className="priceContainer">
          <div className="fromto">{contentTypeOfCare.from}</div>
          <div className="price">{price}</div>
        </div>
        <div className="separate" />
        <div className="priceDisclaimer">{contentTypeOfCare.pricedisclaimer}</div>
      </>
    );
  };

  return (
    <div id="TypeOfCare">
      <div className="wrap">
        <div className="subTitle">{contentTypeOfCare.subtitle}</div>
        <div className="title">{contentTypeOfCare.title}</div>
        <div className="claimerContainer">{claimerContainer()}</div>
        <div className="services">
          {showHoverLight()}
          {(contentTypeOfCare.typeofcareitems || []).map((item, index) => (
            <div key={index} className="serviceItem" onMouseEnter={e => !isMobile && updatePrice(e, item.price)}>
              <div className="serviceContent">
                <div className="iconContainer">
                  <div className="icon">
                    <CheckWhite />
                  </div>
                </div>
                <div className="contentContainer">
                  <div className="listheader">{item.listheader}</div>
                  <div className="listdescription">{item.listdescription}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {contentTypeOfCare.type === "Nurse" && showNurseButton()}
        {}
      </div>
    </div>
  );
};

export default TypeOfCare;
